export const addUnderwriterSubAccount = (data) => ({
  type: "ADD_SUB_ACCOUNT",
  payload: {
    data,
  },
});

export const editUnderwriterSubAccount = (data) => ({
  type: "EDIT_SUB_ACCOUNT",
  payload: {
    data,
  },
});

export const editUnderwriterAccount = (data) => ({
  type: "EDIT_ACCOUNT",
  payload: {
    data,
  },
});

export const addUnderwriterAccount = (data) => ({
  type: "ADD_ACCOUNT",
  payload: {
    data,
  },
});

export const getUnderwriterClientInfo = () => (dispatch) => {
  dispatch({
    type: "GET_UNDERWRITER_CLIENT_INFO",
    payload: {
      endpoint: "/underwriter/clientinfo",
      method: "GET",
    },
  });
};


export const getUnderwriterListForAgent = () => (dispatch) => {
  dispatch({
    type: "GET_UNDERWRITER_LIST_FOR_AGENT",
    payload: {
      endpoint: "/underwriter/list/for/agent",
      method: "GET",
    },
  });
};


export const getPdScore = () => (dispatch) => {
  dispatch({
    type: "GET_PD_SCORE",
    payload: {
      endpoint: "/underwriter/pd/score",
      method: "GET",
    },
  });
};

export const getClientProjectsInfo =
  (data, onSuccess, onFailed) => (dispatch) => {
    dispatch({
      type: "GET_CLIENT_PROJECTS_INFO",
      payload: {
        endpoint: "/underwriter/client/projects/list",
        method: "POST",
        body: data,
      },
      onSuccess,
      onFailed,
    });
  };

export const getClientProjectsInfoForWip =
  (data, query, onSuccess, onFailed) => (dispatch) => {
    dispatch({
      type: "GET_CLIENT_PROJECTS_INFO_WIP",
      payload: {
        endpoint: `/workinprogress/client/projects?filter=${query}`,
        method: "POST",
        body: data,
      },
      onSuccess,
      onFailed,
    });
  };

export const getClientProjectsInfoForWipUnderwriter =
  (data, query, onSuccess, onFailed) => (dispatch) => {
    dispatch({
      type: "GET_CLIENT_PROJECTS_INFO_WIP",
      payload: {
        endpoint: `/underwriter/wip/client/project?filter=${query}`,
        method: "POST",
        body: data,
      },
      onSuccess,
      onFailed,
    });
  };

export const getClientBondsInfo = (data, onSuccess, onFailed) => (dispatch) => {
  dispatch({
    type: "GET_CLIENT_BONDS_INFO",
    payload: {
      endpoint: "/underwriter/client/bonds",
      method: "POST",
      body: data,
    },
    onSuccess,
    onFailed,
  });
};

export const getStatusReportCheck =
  (data, onSuccess, onFailed) => (dispatch) => {
    dispatch({
      type: "GET_STATUS_REPORT_CHECK",
      payload: {
        endpoint: "/underwriter/client/status/report/check",
        method: "POST",
        body: data,
      },
      onSuccess,
      onFailed,
    });
  };

export const postStatusReportTransaction =
  (data, onSuccess, onFailed) => (dispatch) => {
    dispatch({
      type: "POST_STATUS_REPORT_TRANSACTION",
      payload: {
        endpoint: "/underwriter/status/report/transaction",
        method: "POST",
        body: data,
      },
      onSuccess,
      onFailed,
    });
  };

export const latestStatusReportDetails =
  (data, onSuccess, onFailed) => (dispatch) => {
    dispatch({
      type: "VIEW_LATEST_STATUS_REPORT",
      payload: {
        endpoint: "/underwriter/latest/status/report/viewing",
        method: "POST",
        body: data,
      },
      onSuccess,
      onFailed,
    });
  };

export const financialDataAnalysis =
  (data, onSuccess, onFailed) => (dispatch) => {
    dispatch({
      type: "POST_FINANCIAL_DATA_ANALYSIS",
      payload: {
        endpoint: "/underwriter/financial/data/analysis",
        method: "POST",
        body: data,
      },
      onSuccess,
      onFailed,
    });
  };


export const getUnderwriterIdpActiveDocuments =
  (data, onSuccess, onFailed) => (dispatch) => {
    dispatch({
      type: "GET_UNDERWRITER_IDP_ACTIVE_DOCUMENTS",
      payload: {
        endpoint: "/underwriter/idp/active/documents",
        method: "POST",
        body: data,
      },
      onSuccess,
      onFailed,
    });
  };



export const getUnderwriterIdpArchivedDocuments =
  (data, onSuccess, onFailed) => (dispatch) => {
    dispatch({
      type: "GET_UNDERWRITER_IDP_ARCHIVED_DOCUMENTS",
      payload: {
        endpoint: "/underwriter/idp/archived/documents",
        method: "POST",
        body: data,
      },
      onSuccess,
      onFailed,
    });
  };



  export const inviteUnderwriters = (data, onSuccess, onFailed) => (dispatch) => {
    // Invites underwriter to an eSUB, and makes it private
    dispatch({
      type: "INVITE_UNDERWRITERS",
      payload: {
        endpoint: "/esub/invite_underwriters",
        method: "POST",
        body: data,
      },
      onSuccess,
      onFailed,
    });
  };

export const getInstitutionInvitedESUBs = (data, onSuccess, onFailed) => (dispatch) => {
  // Gets ESUBs belonging to the institution
    dispatch({
    type: "GET_INSTITUTION_INVITED_ESUBS",
    payload: {
      endpoint: "/esub/get_institution_esubs",
      method: "GET",
    },
    onSuccess,
    onFailed,
  });
};

